import Loader from '@/components/Loader';

interface Props {}

const LoaderModal = ({}: Props) => {
    return (
        <div className={'w-[40dvh] py-12 max-xl:my-auto'}>
            <Loader />
        </div>
    );
};

export default LoaderModal;
